import { Link } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'
import type { ArticleMeta } from '@/pages/blog/articles'

interface ArticleCardProps {
  article: ArticleMeta
}

export function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link to={`/blog/${article.slug}`}>
      <Card className="h-full card-hover group relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 to-violet-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <CardContent className="py-5 px-5 relative space-y-3">
          <time className="text-xs text-muted-foreground" dateTime={article.publishedAt}>
            {new Date(article.publishedAt).toLocaleDateString('pl-PL', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </time>
          <h2 className="text-lg font-bold text-foreground leading-snug group-hover:text-primary transition-colors">
            {article.title}
          </h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {article.description}
          </p>
          <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary">
            Czytaj dalej
            <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
            </svg>
          </span>
        </CardContent>
      </Card>
    </Link>
  )
}
